/**
 * Flat status pill — the single badge style used across the Platform Admin
 * dashboard (no shadows, no borders). Pass `label` to override display text.
 */
const STATUS_STYLES = {
  active: 'bg-green-50 text-green-700',
  approved: 'bg-green-50 text-green-700',
  paid: 'bg-green-50 text-green-700',
  production: 'bg-green-50 text-green-700',
  required: 'bg-blue-50 text-blue-700',
  trial: 'bg-blue-50 text-blue-700',
  preview: 'bg-blue-50 text-blue-700',
  pending: 'bg-amber-50 text-amber-700',
  suspended: 'bg-red-50 text-red-700',
  failed: 'bg-red-50 text-red-700',
  disabled: 'bg-red-50 text-red-700',
  refunded: 'bg-gray-100 text-gray-600',
  soft_deleted: 'bg-gray-100 text-gray-600',
  optional: 'bg-gray-100 text-gray-500',
};

const StatusBadge = ({ status, label, className = '', ...props }) => (
  <span
    className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium whitespace-nowrap ${
      STATUS_STYLES[String(status || '').toLowerCase()] || 'bg-gray-100 text-gray-600'
    } ${className}`}
    {...props}
  >
    {label || status || 'unknown'}
  </span>
);

export default StatusBadge;
